import { HTTPService, httpService } from "../../services/http.service"
import { NumbersDO } from "../data/numbers"
export class Number {
  constructor(private httpService: HTTPService) { }

  async load():Promise<NumbersDO> {
    return await this.httpService.query(`graph/last_data`, "GET")
  }
}

export const numberService = new Number(httpService)